import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { IntlProvider } from 'react-intl';
import store from "./store";
import App from "./App";

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <IntlProvider locale={"en"} >
        <App />
      </IntlProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);
